import React, { useState } from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Gambar kecil (mis. QR/rekening metode non cash) yang bisa diklik untuk dibuka besar di modal,
// supaya mudah di-scan pelanggan.
const ZoomableImage = ({ src, alt, thumbWidth = 180, thumbSx }) => {
  const [open, setOpen] = useState(false);
  if (!src) return null;

  return (
    <>
      <Box sx={{ textAlign: 'center' }}>
        <Box
          component="img"
          src={src}
          alt={alt}
          onClick={() => setOpen(true)}
          sx={{
            width: thumbWidth,
            maxWidth: '100%',
            border: '1px solid #e5e7eb',
            borderRadius: 1.5,
            p: 1,
            bgcolor: 'white',
            cursor: 'zoom-in',
            ...thumbSx,
          }}
        />
        <Typography variant="caption" sx={{ display: 'block', color: '#6b778c', mt: 0.5 }}>
          Klik gambar untuk memperbesar
        </Typography>
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <IconButton
          aria-label="Tutup"
          onClick={() => setOpen(false)}
          sx={{ position: 'absolute', right: 8, top: 8, bgcolor: 'rgba(255,255,255,0.9)' }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'white', p: 3 }}>
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ZoomableImage;
